// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyBSHOlveVGcq0S37DdQjZ55i_cWpoNjHQQ",
  authDomain: "unison-novel.firebaseapp.com",
  projectId: "unison-novel",
  storageBucket: "unison-novel.appspot.com",
  messagingSenderId: "315189941775",
  appId: "1:315189941775:web:54530d1592cdf2df59b57a",
  measurementId: "G-1VSBREV750"
};